import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QueryFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import { EnumResult, getEnumsInput } from './model';

export function useGetEnums(
  input?: getEnumsInput,
  options?: UseQueryOptions<ApiResult<EnumResult[]>, ApiError>,
) {
  return useQuery<ApiResult<EnumResult[]>, ApiError>(
    ['getEnums', input?.class],
    () =>
      QueryFetchFunction({
        url: `enums/${input?.class}`,
      }),
    { ...options, staleTime: Infinity },
  );
}

export function useGetHealth(
  input?: any,
  options?: UseQueryOptions<{ status: string }, ApiError>,
) {
  return useQuery<{ status: string }, ApiError>(
    ['getHealth', input?.class],
    () =>
      QueryFetchFunction({
        url: `health`,
      }),
    options,
  );
}
